import styled, { css } from 'styled-components'
import { Col } from '@microfrontends/react-components'

export const ContentWrapper = styled(Col)<{
    isPadding?: boolean
    disablePaddingMobile?: boolean
    isMarginTop?: boolean
    isSticky?: boolean
    noPaddingBottom?: boolean
    isTransparentOnMobile?: boolean
    noObjectFit?: boolean
    hasBg?: boolean
    hasBorder?: boolean
}>`
    position: relative;
    background-color: ${({ hasBg }) => (hasBg ? '#fff' : 'unset')};
    border: ${({ hasBorder }) => (hasBorder ? '1px solid rgba(51, 51, 51, 0.08)' : 'unset')};
    display: flex;
    flex-direction: column;
    gap: 20px;

    ${({ isPadding, disablePaddingMobile }) => {
        if (!isPadding) {
            return ''
        }
        return css`
            padding: 40px 32px 32px 32px;
            @media screen and (max-width: 768px) {
                padding: ${disablePaddingMobile ? '0' : '12px'};
            }
        `
    }}
    ${({ isMarginTop }) => {
        if (!isMarginTop) {
            return ''
        }
        return css`
            margin-top: 8px;
            @media screen and (max-width: 768px) {
                margin-top: 8px;
            }
        `
    }}
    ${({ isSticky }) => {
        if (!isSticky) {
            return ''
        }
        return css`
            position: fixed;
            top: 0;
            z-index: 10;
            width: calc(100% - 32px);
            @media screen and (max-width: 768px) {
                width: 100%;
                border-radius: 0 0 6px 6px;
            }
            @media screen and (max-width: 991px) {
                width: 100%;
            }
            @media screen and (min-width: 1200px) {
                max-width: 1170px;
                width: 1138px;
            }
        `
    }}
    ${({ noPaddingBottom }) => {
        if (!noPaddingBottom) {
            return ''
        }
        return css`
            padding-bottom: 0 !important;
        `
    }}
    ${({ isTransparentOnMobile }) => {
        if (!isTransparentOnMobile) {
            return ''
        }
        return css`
            @media screen and (max-width: 768px) {
                background-color: transparent;
                border: 0;
                padding-top: 0 !important;
            }
        `
    }}
`
export const ContanerWithBg = styled.div`
    background-color: #fff;
`

export const MainContent = styled.div`
    width: 100%;
    padding: 0 32px;
    display: flex;
    margin-bottom: 16px;
    background-color: #fff;
    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const Avatar = styled.div`
    display: inline-block;
    border-radius: 6px;
    width: 136px;
    height: 136px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    position: relative;
    overflow: hidden;
    margin-top: -36.5px;
    background-color: #fff;
    z-index: 9;
    @media (max-width: 768px) {
        margin: -66px auto 0 auto;
        width: 110px;
        height: 110px;
    }
`

export const BackgroundContainer = styled.div`
    position: relative;
    width: 100%;
    padding-top: calc((510 / 1920) * 100%);
    border-radius: 6px;
    overflow: hidden;
    @media (max-width: 768px) {
        border-radius: 12px 12px 0 0;
    }
`

export const MainBackgroundImage = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    & > svg {
        width: 100%;
        background-image: linear-gradient(90deg, #005aff 47%, #001744 100%);
    }
`

export const CompanyInfo = styled.div<{ isSticky?: boolean }>`
    display: inline-block;
    vertical-align: top;
    margin-left: 15px;
    width: calc(100% - 400px);
    @media (max-width: 768px) {
        width: 100%;
        margin: 0;
        text-align: center;
        ${({ isSticky }) => {
            if (!isSticky) {
                return ''
            }
            return css`
                display: none;
            `
        }}
    }
`

export const FollowAction = styled.div<{ isSticky?: boolean; isMobile: boolean }>`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    align-content: center;
    width: 262px;
    padding-top: 24px;

    span {
        margin-right: 24px;
    }

    ${({ isMobile, isSticky }) =>
        isMobile &&
        css`
            display: ${isSticky ? 'none' : 'flex'};
            /* flex-direction: column; */
            width: 100%;
            padding-top: 16px;
            span {
                color: #777;
                margin-bottom: 7px;
            }
            button {
                width: 100%;
            }
        `}
    @media (max-width: 768px) {
    }
`

export const CompanyName = styled.h1`
    line-height: 26px;
    margin: 24px 0 8px 0;
    font-size: 24px;
    color: #002c55;
    @media (max-width: 768px) {
        line-height: 24px;
        margin: 24px auto 8px auto;
    }
`

export const CompanyAddress = styled.p<{ isCenter?: boolean; isNoMarginBottom?: boolean }>`
    color: #333;
    font-size: 14px;
    line-height: 16px;
    margin: 0;
    @media (max-width: 768px) {
        margin-bottom: 24px;
        line-height: 22px;
    }
    ${({ isNoMarginBottom }) => {
        if (!isNoMarginBottom) {
            return ''
        }
        return css`
            margin-bottom: 0 !important;
        `
    }}
    ${({ isCenter }) => {
        if (!isCenter) {
            return ''
        }
        return css`
            @media screen and (max-width: 768px) {
                margin-top: 8px;
                width: 100%;
                text-align: center;
            }
        `
    }}
`

export const TabAndShareWrapper = styled.div`
    margin-right: 12.5%;
    &.sticky {
        position: relative;
        margin: 0 -24px;
        width: calc(100% + 48px);
    }
    @media screen and (max-width: 768px) {
        margin-right: 0;
        margin-bottom: 16px;
    }
`

export const TabAndShare = styled.div<{ offset: number }>`
    width: 100%;
    &.sticky {
        position: fixed;
        z-index: 199;
        top: ${({ offset }) => offset}px;
        left: 0;
        right: 0;
        @media (min-width: 769px) {
            padding: 0 16.5px;
        }
    }
`

export const TabSectionWrapper = styled.div<{ width: number }>`
    width: ${({ width }) => width}px;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    &.sticky {
        position: fixed;
        z-index: 199;
        padding: 0 56px;
        box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
        border-bottom: 1px solid #e0e0e0;
        top: ${({ width }) => width}px;
        border-radius: 0;
        @media (min-width: 1200px) {
            width: 1200px;
        }
    }
    @media (max-width: 768px) {
        width: 100% !important;
        flex-direction: column-reverse;
        padding: 0 24px;
    }
    @media (min-width: 992px) {
        margin: 0 auto;
    }
`

export const TabSection = styled.div`
    display: flex;
    @media (max-width: 768px) {
        overflow-x: auto;
        margin-top: 16px;
        justify-content: center;
        align-items: center;
        &::-webkit-scrollbar {
            display: none;
        }
    }
`

export const ShareSection = styled.div<{ isSticky?: boolean }>`
    display: flex;
    ul {
        display: flex;
        list-style: none;
        margin: 0;
        li {
            width: 24px;
            height: 24px;
            opacity: 0.4;
            border-radius: 50%;
            background-color: #d8d8d8;
            display: flex;
            align-items: center;
            justify-content: center;
            align-content: center;
            margin-right: 8px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    span {
        font-size: 14px;
        line-height: 22px;
        color: #333;
    }
    @media (max-width: 768px) {
        width: 100%;
        justify-content: center;
        align-items: center;
        align-content: center;
        margin-top: 20px;
        ${({ isSticky }) => {
            if (!isSticky) {
                return ''
            }
            return css`
                display: none;
            `
        }}
    }
`

export const TabItem = styled.div<{ isSelected?: boolean }>`
    color: #666;
    font-size: 14px;
    line-height: 23px;
    font-weight: 500;
    padding-bottom: 12px;
    padding-top: 12px;
    margin-right: 20px;
    cursor: pointer;
    ${({ isSelected }) => {
        if (!isSelected) {
            return ''
        }
        return css`
            color: #005aff;
            font-weight: 700;
            border-bottom: 2px solid #005aff;
        `
    }}
    &:last-child {
        margin-right: 0;
    }
    &:hover {
        color: #005aff;
    }
    @media (max-width: 768px) {
        padding: 0 12px 12px 12px;
        min-width: fit-content;
    }
`
